import { useTranslation } from 'react-i18next';
import { Field, FieldDescription } from '@/components/ui/field';

interface SupportInfoFieldsProps {
  support: {
    globalEmail: string;
    projectEmail: string;
  };
}

export const SupportInfoFields = ({ support }: SupportInfoFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Field>
        <FieldDescription>
          {t('about.supportText', 'For bug reports or suggestions please contact our global support team:')}{' '}
          <a href={`mailto:${support.globalEmail}`} className="text-primary hover:underline">
            {support.globalEmail}
          </a>
        </FieldDescription>
      </Field>
      <Field>
        <FieldDescription>
          {t('about.projectText', 'For project related questions, please contact your project focal point:')}{' '}
          <a href={`mailto:${support.projectEmail}`} className="text-primary hover:underline">
            {support.projectEmail}
          </a>
        </FieldDescription>
      </Field>
    </>
  );
};
